import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";

export class Footer extends React.Component {
	render(){
		return <footer class="ap-footer">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6 box-logo-address">
								<ul>
									<li><img src="/imga/logo-color.svg"/></li>
									<li>
										<i class="icon-map-point"></i>
										<div class="ap-address">
										<span>Direccion 3333, of. 333</span>
										<span>Capital Federal, Argentina</span>
										</div>
									</li>
								</ul>
							</div>
							<div class="col-md-6 box-phone-mail">
								<ul>
									<li>+54 15 -555-555</li>
									<li>4333-3333<i class="icon-phone"></i></li>
									<li>info@aeroparts.com.ar<i class="icon-email"></i></li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 text-center">


								<ul class="navbar-nav text-center ap-nav-footer">
									<li class="nav-item">
										<NavLink activeClassName={"active"} exact={true} to="/">Inicio</NavLink>
									</li>
									<li class="nav-item">
										<NavLink activeClassName={"active"} to="/nuestros-productos">Nuestros productos</NavLink>
									</li>
									<li class="nav-item">
										<NavLink activeClassName={"active"} to="/como-trabajamos">Como trabajamos</NavLink>
									</li>
									<li class="nav-item">
										<NavLink activeClassName={"active"} to="/noticias">Noticias</NavLink>
									</li>
									<li class="nav-item">
										<NavLink activeClassName={"active"} to="/contactos">Contactos</NavLink>
									</li>
								</ul>
					

							</div>
							<div class="col-md-12 txt-legal">
								<p>@2017 Aeroparts. Todos los derechos reservados</p>
							</div>
						</div>
					</div>
			   </footer>;
	}
} 


// WEBPACK FOOTER //
// ./src/components/Footer.js